/**
 * Format platform stat numbers for hero and summary displays.
 * Below 10k: locale string; at or above 10k: abbreviated k+ suffix.
 */
export function formatStatNumber(value) {
  if (value == null || Number.isNaN(value)) {
    return '—';
  }

  const n = Number(value);
  if (n >= 10000) {
    const k = Math.floor(n / 1000);
    return `${k}k+`;
  }

  return n.toLocaleString('en-US');
}

export default formatStatNumber;
